import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import styles from './SearchResult.module.css'
import { patientActions } from '_actions'
import { PatientCareCenterButton } from '_components'

class SearchResult extends React.Component {
    render() {
        return (
            <span id={this.props.result.id} className={styles.result} style={{ backgroundColor: (this.props.result.id % 2) === 0 ? '#e6f9ff' : 'transparent' }} >
                <span className={styles.result_column} style={{ paddingTop: 2 }}>
                    <PatientCareCenterButton ptno={this.props.result.ptno} size='smaller' />
                </span>
                <span className={styles.result_column}>
                    {'SYS#' + this.props.result.ptno}
                </span>

                <span className={styles.result_column}>
                    {this.props.result.lastName}
                </span>
                <span className={styles.result_column}>
                    {this.props.result.firstName}
                </span>
                <span className={styles.result_column}>
                    {this.props.result.dob}
                </span>
                <span className={styles.result_column}>
                    {this.props.result.ssn}
                </span>
                <span className={styles.result_column}>
                    {this.props.result.location}
                </span>
            </span>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        result: state.entities.search[ownprops.id]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openPatient: bindActionCreators(patientActions.open, dispatch)
    };
}


const connectedSearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResult);
export { connectedSearchResult as SearchResult };